import type { CandidatesReport, ReportRow } from './candidates-report.model';

// ─── «Candidatos a graduación» en diapositivas 16:9 ─────────────────────────
// Sobre el MISMO informe que la página, la carta y el CSV (candidates-report):
// una vista, el mismo total en el resumen, la distribución y la lista.
//
// SIN NOMBRES POR DEFECTO (PM, 2026-10-26): una presentación se proyecta y se
// reenvía. Las cifras van siempre; la lista con nombres solo si quien exporta la
// marca, numerada y agrupada como la distribución, con subtotales.

/** Renglones de la lista por diapositiva (filas y encabezados de grupo). */
export const NAMES_PER_SLIDE = 10;

export type SlideListItem =
  | { kind: 'group'; missing: number; count: number }
  | { kind: 'row'; row: ReportRow };

export interface CandidatesSlidesData {
  report: CandidatesReport;
  /** Vacío salvo que se pidan los nombres. Ya partido en diapositivas. */
  nameSlides: SlideListItem[][];
}

export function buildCandidatesSlides(
  report: CandidatesReport,
  opts: { includeNames: boolean },
): CandidatesSlidesData {
  const nameSlides: SlideListItem[][] = [];
  if (opts.includeNames) {
    const items: SlideListItem[] = report.groups.flatMap((g) => [
      { kind: 'group' as const, missing: g.missing, count: g.rows.length },
      ...g.rows.map((row) => ({ kind: 'row' as const, row })),
    ]);
    for (let i = 0; i < items.length; i += NAMES_PER_SLIDE) {
      nameSlides.push(items.slice(i, i + NAMES_PER_SLIDE));
    }
  }
  return { report, nameSlides };
}

/** Ancho de una barra frente a la más alta (0 si no hay nadie). */
export function barShare(count: number, distribution: ReadonlyArray<{ count: number }>): number {
  const max = Math.max(0, ...distribution.map((d) => d.count));
  return max > 0 ? count / max : 0;
}
